/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class LanguageTextServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取语言值列表
     * @param language (optional) language
     * @return OK
     */
    findAll(language: string | null | undefined): Promise<{ [key: string] : string; }> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-language')+ "/language-text/findall?";
        if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindAll(_response);
        });
    }

    protected processFindAll(response: AxiosResponse): Promise<{ [key: string] : string; }> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key];
                }
            }
            return result200;
        }
        return Promise.resolve<{ [key: string] : string; }>(<any>null);
    }

    /**
     * 导入语言包
     * @param file (optional) file
     * @return OK
     */
    findTenantLanguageList(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-language')+ "/language-text/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindTenantLanguageList(_response);
        });
    }

    protected processFindTenantLanguageList(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 分页获取多语言资源
     * @param culture (optional) 语种
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageList(culture: string | null | undefined, current: number | null | undefined, size: number | null | undefined): Promise<IPageOfApplicationLanguageTextDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-language')+ "/language-text/list?";
        if (culture !== undefined)
            url_ += "culture=" + encodeURIComponent("" + culture) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageList(_response);
        });
    }

    protected processPageList(response: AxiosResponse): Promise<IPageOfApplicationLanguageTextDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfApplicationLanguageTextDto.fromJS(resultData200) : new IPageOfApplicationLanguageTextDto();
            return result200;
        }
        return Promise.resolve<IPageOfApplicationLanguageTextDto>(<any>null);
    }
}

export class LanguageServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取所有的语种列表
     * @return OK
     */
    findLanguageList(): Promise<LanguageVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-language')+ "/language/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindLanguageList(_response);
        });
    }

    protected processFindLanguageList(response: AxiosResponse): Promise<LanguageVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LanguageVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<LanguageVO[]>(<any>null);
    }

    /**
     * 根据租户Id获取语种的列表
     * @return OK
     */
    findTenantLanguageList(): Promise<LanguageDto[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-language')+ "/language/tenant-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindTenantLanguageList(_response);
        });
    }

    protected processFindTenantLanguageList(response: AxiosResponse): Promise<LanguageDto[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LanguageDto.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<LanguageDto[]>(<any>null);
    }
}

export class ApplicationLanguageTextDto implements IApplicationLanguageTextDto {
    /** 主键 */
    id!: string | undefined;
    /** 语种,比如 zh_CN,en_US */
    languageName!: string | undefined;
    /** 模块 */
    source!: string | undefined;
    /** 语言key */
    textKey!: string | undefined;
    /** 语言值 */
    textValue!: string | undefined;

    constructor(data?: IApplicationLanguageTextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.languageName = data["languageName"];
            this.source = data["source"];
            this.textKey = data["textKey"];
            this.textValue = data["textValue"];
        }
    }

    static fromJS(data: any): ApplicationLanguageTextDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageTextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageName"] = this.languageName;
        data["source"] = this.source;
        data["textKey"] = this.textKey;
        data["textValue"] = this.textValue;
        return data; 
    }
}

export interface IApplicationLanguageTextDto {
    /** 主键 */
    id: string | undefined;
    /** 语种,比如 zh_CN,en_US */
    languageName: string | undefined;
    /** 模块 */
    source: string | undefined;
    /** 语言key */
    textKey: string | undefined;
    /** 语言值 */
    textValue: string | undefined;
}

export class IPageOfApplicationLanguageTextDto implements IIPageOfApplicationLanguageTextDto {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ApplicationLanguageTextDto[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfApplicationLanguageTextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ApplicationLanguageTextDto.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfApplicationLanguageTextDto {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfApplicationLanguageTextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfApplicationLanguageTextDto {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ApplicationLanguageTextDto[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class LanguageDto implements ILanguageDto {
    /** 语言显示名称,比如中文、English  */
    displayName!: string | undefined;
    /** 旗帜图标 */
    icon!: string | undefined;
    /** 主键 */
    id!: string | undefined;
    /** 是否默认(0:默认) */
    isDefault!: number | undefined;
    /** 启用禁用(0:启用，1:禁用) */
    isDisabled!: number | undefined;
    /** 名称,比如 zh_CN,en_US 等 */
    name!: string | undefined;
    /** 租户code */
    tenantId!: string | undefined;

    constructor(data?: ILanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.icon = data["icon"];
            this.id = data["id"];
            this.isDefault = data["isDefault"];
            this.isDisabled = data["isDisabled"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): LanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["id"] = this.id;
        data["isDefault"] = this.isDefault;
        data["isDisabled"] = this.isDisabled;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface ILanguageDto {
    /** 语言显示名称,比如中文、English  */
    displayName: string | undefined;
    /** 旗帜图标 */
    icon: string | undefined;
    /** 主键 */
    id: string | undefined;
    /** 是否默认(0:默认) */
    isDefault: number | undefined;
    /** 启用禁用(0:启用，1:禁用) */
    isDisabled: number | undefined;
    /** 名称,比如 zh_CN,en_US 等 */
    name: string | undefined;
    /** 租户code */
    tenantId: string | undefined;
}

export class LanguageVO implements ILanguageVO {
    /** 语言显示名称,比如中文、English  */
    displayName!: string | undefined;
    /** 名称,比如 zh_CN,en_US 等 */
    name!: string | undefined;

    constructor(data?: ILanguageVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): LanguageVO {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        return data; 
    }
}

export interface ILanguageVO {
    /** 语言显示名称,比如中文、English  */
    displayName: string | undefined;
    /** 名称,比如 zh_CN,en_US 等 */
    name: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}